import React, { useContext } from 'react';
import { OnlineBookingContext } from '..';

const BottomNav = ({ canContinue = false, values }) => {
  const { forwardNav, backwardNav } = useContext(OnlineBookingContext);

  return (
    <div className="c-online-booking__bottom-nav">
      <button
        className="c-online-booking__bottom-nav__button o-btn o-btn--soft-sky"
        onClick={() => backwardNav()}
      >
        Back
      </button>

      <button
        className="c-online-booking__bottom-nav__button o-btn o-btn--soft-sky"
        onClick={() => canContinue && forwardNav(values)}
        disabled={!canContinue}
      >
        Continue
      </button>
    </div>
  );
};

export default BottomNav;
